package com.appcreator.app.utils

import kotlinx.browser.window

actual fun addToClipboard(value: String) {
    window.navigator.clipboard.writeText(value)
}